export const rotateAround = <T>(arr: T[], fulcrum: T | null): T[] => {
  const fulcrumIndex = arr.indexOf(fulcrum as T);
  return fulcrumIndex === -1
    ? arr
    : arr.slice(fulcrumIndex).concat(arr.slice(0, fulcrumIndex));
};

export const includes = <T extends U, U>(
  list: ReadonlyArray<T>,
  item: U
): item is T => list.includes(item as T);
